import React, { useEffect, useState,useContext } from "react";
import "../../Assessts/Styles/SamagraDashboard/CircularAnalysis.scss";
import QuestionChart from "./QChart";
import DetailedLOPerformance from "./DetailedPerformance";
import axiosInstance from "../../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import QuestionAnalysis from "./QuestionWiseAnalysis";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";

const QPerformance = () => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const { SetLoad } = useContext(LoadContext);
  const [GradeOptions, SetGradeOptions] = useState();
  const [SGrade, SetSGrade] = useState();

  const [SubOptions, SetSubOptions] = useState();
  const [SSub, SetSSub] = useState();

  const [QGraph, SetQGraph] = useState();
  const [LO, SetLO] = useState();

  const [StudentData, SetStudentData] = useState();

  const GetQuestionPerformance = async (Sub, Grade) => {
    SetLoad(true);
    try {
      const res = await axiosInstance.get(`/Principal/GetPrincipalQuestionWisePerformance?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&SubjectName=${Sub}&Grade=${Grade}`);
      console.log(res.data,"maths")
      const Format = res.data.map((Q) => ({
        Labels: Q.questionId,
        Percetage: Q.averageScore
      }))
      console.log("Format",Format);
      SetQGraph(Format);
      SetLoad(false);
    }
    catch (err) { console.log(err) }
  }

  const GetQuestionLOPerformance = async (Sub, Grade) => {
    try {
      const res = await axiosInstance.get(`/Principal/GetLOPerformanceBreakdown?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&Grade=${Grade}&SubjectName=${Sub}`);
      SetLO(res.data);
    }
    catch (err) { console.log(err) }
  }

  const GetSubjects = async (Grade) => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetResponceAssessmentSubjects?ContestcreationId=${SelectDate?.value}&Grade=${Grade}&AssessmentTypeId=3`);
      const FormatedOptions = res.data?.map((item) => ({
        display: item?.subjectName,
        value: item?.subjectName,
      }));
      SetSubOptions(FormatedOptions);
      SetSSub(FormatedOptions[0]?.value);
      GetQuestionPerformance(FormatedOptions[0]?.value, Grade);
      GetQuestionLOPerformance(FormatedOptions[0]?.value, Grade);
    }
    catch (err) { console.log(err) }
  }

  const GetAssGrades = async () => {
    SetLoad(true)
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetGradeBasedOnInstituteAndSociety?AssessmentTypeNo=${SelectDate?.assessmentTypeNo}&InstituteId=${items?.instituteId}&Year=${USYear?.value}&SocietyId=${items?.societyId || 0
        }`,
      );
      const FormatedOptions = res.data?.[0]?.grade.split(",").map((item) => ({
        display: `Grade ${item.trim()}`,
        value: item.trim(),
      }));
      SetGradeOptions(FormatedOptions);
      SetSGrade(FormatedOptions[0]?.value);
      GetSubjects(FormatedOptions[0]?.value);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetAssGrades();
  }, [])
  const GetQuestionWiseanalysis = async (QID) => {
    try {
      const res = await axiosInstance.get(`/Principal/GetStudentResponsesbyQuestion?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&QuestionId=${QID}`);
      SetStudentData(res.data);
    }
    catch (err) { console.log(err) }
  }

  const GetLowiseStudents = async (Lid, Sub) => {
    try {
      const res = await axiosInstance.get(`/Principal/GetDetailStudentPerformancebyLO?schoolId=${items.schoolId}&contestCreationId=${SelectDate?.value}&grade=${SGrade}&subjectName=${Sub}&loId=${Lid}`);
      SetStudentData(res.data);
    }
    catch (err) { console.log(err) }
  }
  return (
    <>
      <div className="performance-container">
        <div className="page-header">
          <h1>Performance breakdown by Learning outcomes</h1>
          <p>
            Performance breakdown by Learning Objective (LO) from the mapped
            curriculum
          </p>
        </div>

        <div className="Sperformance-card">
          <div className="card-top">
            <div>
              <h2>Question-wise Performance (Q1 - Q{QGraph?.length})</h2>
              <p>
                Average percentage of correct answers per question. Click bar to
                view students.
              </p>
            </div>

            <div className="top-actions">
              <button className="repository-btn"> 📄 View Paper Repository </button>

              <DropdownValues className="NCLDropdown" options={SubOptions} selectoption={SSub}
                onChange={(e) => { SetSSub(e.target.value); GetQuestionPerformance(e.target.value, SGrade);
                  GetQuestionLOPerformance(e.target.value, SGrade); }}  />

              <DropdownValues className="NCLDropdown" options={GradeOptions} selectoption={SGrade}
                onChange={(e) => { SetSGrade(e.target.value); GetQuestionPerformance(SSub, e.target.value);
                  GetQuestionLOPerformance(SSub, e.target.value); }} />
            </div>
          </div>

          {QGraph && <div className="chart-wrapper " >
              <QuestionChart data={QGraph} onQuestionClick={(questionId) => { GetQuestionWiseanalysis(questionId); }} />
            </div>}

          <div className="table-scroll">
            <table className="score-table">
              <thead>
                <tr>
                  <th>Question</th>
                  {QGraph?.map((item) => ( <th key={item.Labels}>{item.Labels}</th> ))}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="row-title">Avg Score</td>
                  {QGraph?.map((item) => (
                    <td key={item.Labels} className={ item.Percetage < 60 ? "low-score" : "good-score" } >
                      {item.Percetage}% </td> ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <DetailedLOPerformance Data={LO} GetLovid={(Lid, Sub) => { GetLowiseStudents(Lid, Sub); }} />

      {StudentData && <QuestionAnalysis SData={StudentData} SetSData={SetStudentData} />}
    </>
  );
};

export default QPerformance;